// extracted by mini-css-extract-plugin
module.exports = {"genericIcon":"AvatarColor__genericIcon","genericIconLetter":"AvatarColor__genericIconLetter"};